// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__1Fv34","container":"styles_container__DjwSk","title":"styles_title__uRs_D","wrapper":"styles_wrapper__YLylM","answer":"styles_answer__2U_Fi"};